//
//
//
//
//
//
//

import cookie from 'babyfs-cookie';
import typer from 'babyfs-type';
import env from 'babyfs-env';
export default {
  mounted: function mounted() {
    this.setCookie();
  },

  methods: {
    setCookie: function setCookie() {
      if (process.env.NODE_ENV === 'development' && typer.isStringEmpty(cookie.get('ba_a_uid'))) {
        cookie.set('X-Root-Auth-Token', '/71bXzqKCXg1u2h6qA7iOAsTxgtwoRp8iuI18aGc5CRYj21rFjBu1Yy35lSF3bwQbJXPecTEzJMHcovdIF9w2A==');
        cookie.set('ba_a_uid', '1');
      }
    }
  }
};